import { IconCopy } from '@tabler/icons-react';
import { shortId } from '../../format';

function copyText(value?: string | null) {
  if (!value) return;
  void navigator.clipboard?.writeText(value);
}

export function CopyId({
  value,
  label,
}: {
  value?: string | null;
  label: string;
}) {
  if (!value) return <span className="text-muted-foreground">-</span>;
  return (
    <button
      type="button"
      className="inline-flex max-w-full items-center gap-1 rounded px-1 py-0.5 font-mono text-xs text-muted-foreground hover:bg-muted hover:text-foreground"
      title={`Copy ${label}`}
      onClick={() => copyText(value)}
    >
      <span className="truncate">{shortId(value)}</span>
      <IconCopy className="size-3 shrink-0" />
    </button>
  );
}
